import { MetaLoader, MetaStaticLoader, PageTitlePositioning } from '@ngx-meta/core';
export function metaFactory() {
    return new MetaStaticLoader({
        pageTitlePositioning: PageTitlePositioning.PrependPageTitle,
        pageTitleSeparator: ' - ',
        applicationName: 'RVTS',
        defaults: {
            title: 'RVTS',
            description: 'De regionale ressurssentrene om vold, traumatisk stress og selvmordsforebygging',
            'og:type': 'website',
            'og:locale': 'no',
        }
    });
}
const ɵ0 = (metaFactory);
export class CoreModule {
}
export { ɵ0 };
